import {Injectable} from 'ng-metadata/core';

@Injectable()
export class TagsResultsService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsResults/tagsResults.service.ts